module.exports = __webpack_public_path__ + "static/media/Rahul Shah.0f5736f7.png";